import React from 'react';
import {connect} from 'react-redux';
import Modal from 'react-bootstrap/Modal';
import {ReactSVG} from 'react-svg';
import Cookies from 'universal-cookie';
import self from '../../apis/self';
import Slider from 'react-slick';
import {displayOnboardingPopup, loadOnboardingPopupData} from '../../actions';
import Parser from 'html-react-parser';
import ReactPlayer from 'react-player/lazy';
import moment from 'moment';
import {trans} from '../../config/translation';

/**
 * React Component that handles modal popup for Onboarding.
 * This Component is using Bootstrap Modal as base
 */
class OnboardingPopup extends React.Component {
    constructor(props) {
        super(props);
        this.next = this.next.bind(this);
        this.prev = this.prev.bind(this);
        this.state = {
            sliderShow: false,
            slideIndex: 0
        };
        this.onHide = this.onHide.bind(this);
        this.onShow = this.onShow.bind(this);
        this.reactPlayer = [];
    }

    /**
     * get layer list from API
     *
     * @returns {Promise<void>}
     */
    getOnboardingItems = async () => {
        let url = '/onboardings';
        if (window.outerWidth < 1023) {
            url = '/onboardings/mobile';
        }
        const response = await self.get(url, {
            timeout: 40000
        });
        if (response) {
            this.props.loadOnboardingPopupData(response.data);
            const cookies = new Cookies();
            if (cookies.get('prims_onboarding_showed') != 1) {
                this.props.displayOnboardingPopup(true);
                cookies.set('prims_onboarding_showed', 1, {path: '/', expires: moment().add(30, 'days').toDate()});
            }
        } else {
            //TODO: ERROR HANDLING ON GET ONBOARDING DATA
            console.log('getOnboardingItems failed');
            console.log(response);
        }
    }

    /**
     * handle slick slide next event
     */
    next() {
        this.setState({slideIndex: this.state.slideIndex + 1});
        // this.reactPlayer[this.state.slideIndex].seekTo(0);
        this.slider.slickNext();
    }

    /**
     * handle slick slide prev event
     */
    prev() {
        this.setState({slideIndex: this.state.slideIndex - 1});
        // this.reactPlayer[this.state.slideIndex].seekTo(0);
        this.slider.slickPrev();
    }

    /**
     * onslider change event
     *
     * @param oldIndex
     * @param newIndex
     */
    onSliderChange = (oldIndex, newIndex) => {
        this.setState({slideIndex: newIndex});
        // this.reactPlayer[oldIndex].seekTo(0);
        // this.reactPlayer[newIndex].seekTo(0);
    }

    /**
     * on modal show event handler
     * add timeout to show slider to prevent jumping in display
     */
    onShow() {
        setTimeout(
            function () {
                this.setState({sliderShow: true});
                // this.reactPlayer[0].seekTo(0);
            }
                .bind(this),
            200
        );
    }

    /**
     * hide modal event handler
     */
    onHide() {
        this.setState({slideIndex: 0});
        this.props.displayOnboardingPopup(false);
    }

    /**
     * on modal exited
     * set slider back to hidden
     */
    onExited() {
        this.setState({sliderShow: false});
    }

    componentDidMount() {
        if (this.props.onboardingPopupData.items.length > 0) {
            const cookies = new Cookies();
            if (cookies.get('prims_onboarding_showed') != 1) {
                this.props.displayOnboardingPopup(true);
            }
        } else {
            this.getOnboardingItems();
        }
    }

    render() {
        const SliderSettings = {
            dots          : true,
            arrows        : false,
            infinite      : false,
            slidesToShow  : 1,
            slidesToScroll: 1,
            lazyLoad      : true,
            beforeChange  : this.onSliderChange,
            // adaptiveHeight: true
        };
        const items = this.props.onboardingPopupData.items ? this.props.onboardingPopupData.items : [];
        return (
            <Modal id="onboarding-popup"
                   show={this.props.onboardingPopupData.status}
                   onEntered={() => this.onShow()}
                   onHide={this.onHide}
                   onExited={() => this.onExited()}
                   backdrop="static"
                   className="onboarding-popup-container"
                   style={this.state.sliderShow ? {opacity: 'visible'} : {visibility: 'hidden'}}
                   aria-labelledby="contained-modal-title-vcenter"
                   centered
            >
                <button className="btn btn-close"
                        // onClick={() => this.props.displayOnboardingPopup(false)}>
                        onClick={this.onHide}>
                    <ReactSVG className="close-icon react-svg" src="/img/maps/icon/close.svg"/>
                </button>
                <Modal.Body>
                    <div>
                        <Slider ref={c => (this.slider = c)} {...SliderSettings}>
                            {
                            items.map((item, index) => {
                                return (
                                    <div className="onboarding-item" key={`onboarding-item-${index}`}>
                                        <div className="inner-container">
                                            <div className="img-container">
                                            {item.type === 'video' ?
                                                <ReactPlayer className='react-player'
                                                             url={`/storage/onboarding/${item.video}`}
                                                             loop={ index !== 0 ? true : false }
                                                             // light={true}
                                                             playing={index === this.state.slideIndex}
                                                             controls={false}
                                                             muted={true}
                                                             playsinline={true}
                                                             width="100%"
                                                             height="100%"
                                                             ref={(ref) => this.reactPlayer[index] = ref}
                                                             />
                                                : <img src={`/storage/onboarding/${item.image}`} alt=""/>
                                            }
                                                    </div>
                                            <div className="text-container">
                                                <h3>{item.title}</h3>
                                                {item.description ? Parser(item.description) : ''}
                                            </div>
                                            <div className="btn-container">
                                                {/* if back button available (index != 0) */}
                                                {index !== 0 ?
                                                    <button className="btn btn-light" onClick={this.prev}>
                                                        {trans('onboarding.back')}
                                                    </button> : ''}
                                                {/* if next button available (index<last)*/}
                                                {index < this.props.onboardingPopupData.items.length - 1 ?
                                                    <button className="btn btn-primary" onClick={this.next}>
                                                        {trans('onboarding.next')}
                                                    </button> : ''}
                                                {/* if close button avaliable */}
                                                {index === this.props.onboardingPopupData.items.length - 1 ?
                                                    <button className="btn btn-primary"
                                                            onClick={() => this.props.displayOnboardingPopup(false)}>
                                                        {trans('onboarding.onward')}
                                                    </button> : ''}
                                            </div>
                                        </div>
                                    </div>
                                );
                            })
                        }
                        </Slider>
                    </div>
                </Modal.Body>
            </Modal>
        );
    }
}

const mapActionToProps = {
    displayOnboardingPopup,
    loadOnboardingPopupData
};

const mapStateToProps = state => {
    return {
        onboardingPopupData: state.onboardingPopupData
    };
};
export default connect(mapStateToProps, mapActionToProps)(OnboardingPopup);